module.exports = __webpack_public_path__ + "static/bgvideo-54c654b2cc743d7e4a28be25989a99ad.mp4";